import React, {useState} from "react";
import api from "../../Utils/Axios";
import {toast} from "react-toastify";

const ContactForm = () => {
    const [formData, setFormData] = useState({
        fullname: '',
        subject: '',
        message: '',
        email: '',
        phone: ''
    });

    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            console.log(formData)
            const response = await api.post("contact-us/", formData)
            toast.success("Form Submitted SuccessFully")

        } catch (error) {
            alert(`Error: ${error.message}`);
        }
    };

    return (
        <form
            id="contact-form"
            className="default-form2 contact-form-validated"
            onSubmit={handleSubmit}
        >
            <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-6">
                    <div className="input-box">
                        <input
                            type="text"
                            name="fullname"
                            value={formData.fullname}
                            onChange={handleChange}
                            placeholder="Full Name"
                            required
                        />
                    </div>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-6">
                    <div className="input-box">
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="Your Email"
                            required
                        />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12">
                    <div className="input-box">
                        <input
                            type="text"
                            name="subject"
                            value={formData.subject}
                            onChange={handleChange}
                            placeholder="Message Subject"
                            required
                        />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-xl-12">
                    <div className="input-box">
                        <textarea
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                            placeholder="Write Message.."
                            required
                        />
                    </div>
                </div>
                <div className="col-xl-12 col-lg-12 col-md-12">
                    <div className="contact-one__form-btn">
                        <button
                            className="button-style-1"
                            type="submit"
                        >
                            Send Now
                        </button>
                    </div>
                </div>
            </div>
        </form>
    );
}

export default ContactForm;
